import { createNotification } from "../components/Notifications/Notifications";
import {
  SET_COURSES_COUNT,
  SET_COURSES_LIST,
  SET_COURSES_LOADING,
  SET_COURSES_PAGE,
  SET_CURRENT_COURSE,
  SET_COURSES_ALIAS_LIST,
  SET_COURSES_ALIAS_LIST_LOADING,
  SET_EDU_DIR_LIST_LOADING,
  SET_EDU_DIR_LIST,
  SET_CULTURE_LIST_LOADING,
  SET_CULTURE_LIST,
  SET_COMPETENCE_LIST,
  SET_COMPETENCE_LIST_LOADING,
  SET_COURSES_FILES_LIST,
} from "./types";

import { api } from "../App";


export const setPage = (pageNumber) => ({ type: SET_COURSES_PAGE, payload: pageNumber })

// Без пагинации в UI: сервер всегда применяет LIMIT (дефолт 100), поэтому просим сразу всё
export const getCoursesList = (params = {}) => async (dispatch) => {
  dispatch({ type: SET_COURSES_LOADING, payload: true });
  const urlParams = new URLSearchParams({ limit: 9999 });
  if (params.title_search) urlParams.append('title_search', params.title_search);
  try {
    const { data } = await api.get(`/courses?${urlParams}`);
    const { cnt: count, courses } = data;
    dispatch({ type: SET_COURSES_LIST, payload: { courses } });
    dispatch({ type: SET_COURSES_COUNT, payload: { count } });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_COURSES_LOADING, payload: false });
  }
};

export const getCurrentCourse = (courseId) => async (dispatch, getState) => {
  dispatch({ type: SET_COURSES_LOADING, payload: true });
  try {
    const { data } = await api.get(`/courses/${courseId}`);
    dispatch({ type: SET_CURRENT_COURSE, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_COURSES_LOADING, payload: false });
  }
};

export const deleteCourse = (courseId, listParams) => async (dispatch) => {
  dispatch({ type: SET_COURSES_LOADING, payload: true });
  try {
    await api.delete(`/courses/${courseId}`);
    createNotification('success', 'Предмет удалён');
    await dispatch(getCoursesList(listParams));
  } catch (ERR) {
    createNotification('error', 'Ошибка удаления');
  } finally {
    dispatch({ type: SET_COURSES_LOADING, payload: false });
  }
};

export const updateCourse = (courseId, data, listParams) => async (dispatch) => {
  dispatch({ type: SET_COURSES_LOADING, payload: true });
  let success
  try {
    await api.put(`/courses/${courseId}`, data);
    createNotification('success', 'Изменения сохранены');
    await dispatch(getCoursesList(listParams));
    success = true
  } catch (ERR) {
    createNotification('error', 'Ошибка сохранения')
  } finally {
    dispatch({ type: SET_COURSES_LOADING, payload: false });
  }
  return success
};

export const createCourse = (info, listParams) => async (dispatch) => {
  dispatch({ type: SET_COURSES_LOADING, payload: true });
  let success
  try {
    await api.post(`/courses`, info);
    createNotification('success', 'Предмет добавлен');
    await dispatch(getCoursesList(listParams));
    success = true
  } catch (ERR) {
    createNotification('error', 'Ошибка сохранения')
  } finally {
    dispatch({ type: SET_COURSES_LOADING, payload: false });
  }
  return success
};

export const getCoursesAlias = () => async (dispatch, getState) => {
  dispatch({ type: SET_COURSES_ALIAS_LIST_LOADING, payload: true });
  try {
    const { data } = await api.get(`/courses/alias`);
    dispatch({ type: SET_COURSES_ALIAS_LIST, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_COURSES_ALIAS_LIST_LOADING, payload: false });
  }
};

export const getEduDirList = () => async (dispatch, getState) => {
  dispatch({ type: SET_EDU_DIR_LIST_LOADING, payload: true });
  try {
    const { data } = await api.get(`/edu_direction`);
    dispatch({ type: SET_EDU_DIR_LIST, payload: data.edu_direction });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_EDU_DIR_LIST_LOADING, payload: false });
  }
};

export const getCultureList = () => async (dispatch, getState) => {
  dispatch({ type: SET_CULTURE_LIST_LOADING, payload: true });
  try {
    const { data } = await api.get(`/culture`);
    dispatch({ type: SET_CULTURE_LIST, payload: data.culture });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_CULTURE_LIST_LOADING, payload: false });
  }
};

export const getCompetence = () => async (dispatch, getState) => {
  dispatch({ type: SET_COMPETENCE_LIST_LOADING, payload: true });
  try {
    const { data } = await api.get(`/competence`);
    dispatch({ type: SET_COMPETENCE_LIST, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_COMPETENCE_LIST_LOADING, payload: false });
  }
};

////////////////////////////// FILES //////////////////////////////
export const createCoursesFile = (data, cid) => async (dispatch, getState) => {
  const fd = new FormData();
  fd.append("file", data);
  let success
  try {
    dispatch({ type: SET_COURSES_LOADING, payload: true });
    await api.post(`/courses/file/${cid}`, fd);
    await dispatch(getCoursesFileList(cid))
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_COURSES_LOADING, payload: false });
    return success
  }
}

export const getCoursesFile = (file_name, cid) => async (dispatch) => {
  try {
    dispatch({ type: SET_COURSES_LOADING, payload: true });
    const { data } = await api.get(`/courses/file/${cid}/${file_name}`, { responseType: 'blob' });
    const objectURL = URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = objectURL;
    link.download = file_name;
    link.click();
    URL.revokeObjectURL(objectURL);
  } catch (ERR) {
    createNotification('error', 'Ошибка скачивания файла');
  } finally {
    dispatch({ type: SET_COURSES_LOADING, payload: false });
  }
};

//список файлов
export const getCoursesFileList = (cid) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_COURSES_LOADING, payload: true });
    const { data } = await api.get(`/courses/${cid}/file`);
    dispatch({ type: SET_COURSES_FILES_LIST, payload: data });
  } catch (ERR) {
    dispatch({ type: SET_COURSES_FILES_LIST, payload: [] });
  } finally {
    dispatch({ type: SET_COURSES_LOADING, payload: false });
  }
};

export const deleteCoursesFile = (fileName, cid) => async (dispatch, getState) => {
  try {
    await api.delete(`/courses/file/${cid}/${fileName}`);
    createNotification('success', 'Успешно удалено');
    await dispatch(getCoursesFileList(cid))
  } catch (error) {
    createNotification('error', 'Ошибка удаления');
  }
};
